/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import {
  IconButton,
  Typography,
  Box,
  Dialog,
  Stack,
  Checkbox,
  Paper,
  InputAdornment,
  TextField,
  FormGroup,
  FormControlLabel,
  Button,
  useMediaQuery,
  SwipeableDrawer,
  CircularProgress,
} from "@mui/material";
import event_cancel from "../../assets/icons/preveiw_cancel.svg";
import searchIcon from "../../assets/icons/search.svg";
import { LoadingButton } from "@mui/lab";
import { enqueueSnackbar } from "notistack";
import getStaff from "src/services/events/getStaff";
import { useAuthContext } from "src/auth/useAuthContext";
import postGenerateLink from "src/services/events/postGenerateLink";
import LoadingInPage from "src/components/LoadingInPage";
import eventsAffiliateData from "src/services/events/getAffiliate";

const ForStaff = (props) => {
  const { vendor, user, logout } = useAuthContext();
  const [search, setSearch] = useState("");
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [staffList, setStaffList] = useState();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getStaff(vendor, user, "", logout, "", "", 1000);
      if (response) {
        setLoading(true);
        setStaffList(
          response?.payload?.filter((data) => data?.status !== false)
        );
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCheckboxChange = (e, id) => {
    const checked = e.target.checked;

    if (Array.isArray(checkedItems)) {
      if (checked) {
        setCheckedItems([...checkedItems, id]);
        // setSelectAll(true);
        if (staffList?.length === checkedItems?.length + 1) {
          setSelectAll(true);
        }
      } else {
        setCheckedItems(checkedItems.filter((drinksId) => drinksId !== id));
        setSelectAll(false);
      }
    } else {
      console.error("checkedItems is not an array:", checkedItems);
      setCheckedItems([]);
      setSelectAll(false);
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setCheckedItems(staffList?.map((staff) => staff?.partner?._id));
      setSelectAll(event.target.checked);
    } else {
      setCheckedItems([]);
      setSelectAll(event.target.checked);
    }
  };

  useEffect(() => {
    if (staffList?.length === checkedItems?.length) {
      setCheckedItems(staffList?.map((staff) => staff?._id));
      setSelectAll(true);
    }
  }, []);

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const matches = useMediaQuery("(max-width:600px)");
  const filteredItems = staffList?.filter(
    (staff) =>
      staff?.partner?.name?.toLowerCase()?.includes(search?.toLowerCase()) &&
      staff?.partner?.status
  );

  const handleAddStaff = async () => {
    setIsSubmitting(true);
    const data = {
      staffs: checkedItems,
      event: props?.eventData?._id,
      eventName: props?.eventData?.name,
    };
    const response = await postGenerateLink(user, data, logout);
    setIsSubmitting(false);
    if (response) {
      enqueueSnackbar("Generate Link Successfully", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      props?.onClose();
      props?.setStatus(true);
      const response = await eventsAffiliateData(user, props?.eventData?._id, logout)
      props.setAffiliationData(response)
      props?.setStatus(false);
    }
  };
  return (
    <>
      {matches ? (
        <SwipeableDrawer
          anchor="bottom"
          open={props?.open}
          onClose={props?.onClose}
        >
          <Stack spacing={2} p="0.5rem 1rem" maxHeight="400px">
            <Stack
              sx={{
                WebkitOverflowScrolling: "touch",
                "&::-webkit-scrollbar": {
                  width: "2px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "main.primary",
                },
              }}
              spacing={2}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h3" color="primary">
                  Generate for Active Staff
                </Typography>
                <IconButton onClick={props?.onClose}>
                  <Box component="img" src={event_cancel} />
                </IconButton>
              </Stack>
              {loading ? (
                <CircularProgress />
              ) : (
                <Stack spacing={2} sx={{ padding: "0px 10px" }}>
                  {/* Search */}
                  <TextField
                    fullWidth
                    id="Search"
                    variant="outlined"
                    size="small"
                    placeholder="Search"
                    value={search}
                    onChange={handleSearch}
                    sx={{
                      bgcolor: "#FFFFFF",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Box
                            component="img"
                            src={searchIcon}
                            alt="Search Icon"
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* Select All Button */}

                  <Box width="100%">
                    <Paper
                      style={{
                        border: "1px solid #E4E5E7",
                        maxHeight: 200,
                        overflow: "auto",
                        // "&::-webkit-scrollbar": {
                        //   width: "6px",
                        // },
                        // "&::-webkit-scrollbar-thumb": {
                        //   backgroundColor: "#ccc",
                        // },
                      }}
                    >
                      <FormControlLabel
                        sx={{ px: 2 }}
                        control={
                          <Checkbox
                            onClick={handleSelectAll}
                            checked={selectAll}
                          />
                        }
                        label="Select All"
                      />
                      {filteredItems?.map((staff, index) => (
                        <FormGroup key={index} pr={4}>
                          <FormControlLabel
                            sx={{ px: 2 }}
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleCheckboxChange(e, staff?.partner?._id)
                                }
                                checked={checkedItems?.includes(
                                  staff?.partner?._id
                                )}
                              />
                            }
                            label={staff?.partner?.name}
                          />
                        </FormGroup>
                      ))}
                    </Paper>
                  </Box>
                </Stack>
              )}
              <Stack
                direction="row"
                sx={{ justifyContent: "space-between", pl: 1, pr: 1 }}
              >
                <Button variant="outlined" onClick={props?.onClose}>
                  Cancel
                </Button>
                <LoadingButton
                  loading={isSubmitting}
                  variant="contained"
                  onClick={handleAddStaff}
                >
                  Add ({checkedItems?.length}) Staff
                </LoadingButton>
              </Stack>
            </Stack>
          </Stack>
        </SwipeableDrawer>
      ) : (
        <Dialog
          open={props?.open}
          onClose={props?.onClose}
          aria-labelledby="delete-modal-title"
          aria-describedby="delete-modal-description"
        >
          <Stack
            p={3}
            sx={{
              minWidth: "535px",
              WebkitOverflowScrolling: "touch",
              "&::-webkit-scrollbar": {
                width: "2px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "main.primary",
              },
            }}
            spacing={2}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h3" color="primary">
                Generate for Active Staff
              </Typography>
              <IconButton onClick={props?.onClose}>
                <Box component="img" src={event_cancel} />
              </IconButton>
            </Stack>
            {loading ? (
              <LoadingInPage />
            ) : (
              <Stack spacing={2} sx={{ padding: "0px 10px" }}>
                {/* Search */}
                <TextField
                  fullWidth
                  id="Search"
                  variant="outlined"
                  size="small"
                  placeholder="Search"
                  value={search}
                  onChange={handleSearch}
                  sx={{
                    bgcolor: "#FFFFFF",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          component="img"
                          src={searchIcon}
                          alt="Search Icon"
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Select All Button */}

                <Box width="100%">
                  <Paper
                    style={{
                      border: "1px solid #E4E5E7",
                      maxHeight: 200,
                      overflow: "auto",
                      // "&::-webkit-scrollbar": {
                      //   width: "6px",
                      // },
                      // "&::-webkit-scrollbar-thumb": {
                      //   backgroundColor: "#ccc",
                      // },
                    }}
                  >
                    <FormControlLabel
                      sx={{ px: 2 }}
                      control={
                        <Checkbox
                          onClick={handleSelectAll}
                          checked={selectAll}
                        />
                      }
                      label="Select All"
                    />
                    {filteredItems?.map((staff, index) => (
                      <FormGroup key={index} pr={4}>
                        <FormControlLabel
                          sx={{ px: 2 }}
                          control={
                            <Checkbox
                              onChange={(e) =>
                                handleCheckboxChange(e, staff?.partner?._id)
                              }
                              checked={
                                checkedItems?.includes(staff?.partner?._id) ||
                                false
                              }
                            />
                          }
                          label={staff?.partner?.name}
                        />
                      </FormGroup>
                    ))}
                  </Paper>
                </Box>
              </Stack>
            )}
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", pl: 1, pr: 1 }}
            >
              <Button variant="outlined" onClick={props?.onClose}>
                Cancel
              </Button>
              <LoadingButton
                loading={isSubmitting}
                variant="contained"
                onClick={handleAddStaff}
              >
                Add ({checkedItems?.length}) Staff
              </LoadingButton>
            </Stack>
          </Stack>
        </Dialog>
      )}
    </>
  );
};

export default ForStaff;
